import { CSSProperties } from 'react';
import { Theme } from '@mui/material';
import { Colors } from '../../../utils/theme';

export const searchBarStyles = (theme: Theme, isFullWidth?: boolean) => ({
	root: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
	},
	fieldWrapper: {
		width: isFullWidth ? '100%' : 'auto',
	},
	textField: {
		minWidth: '8rem',

		'& .MuiInput-input': {
			fontFamily: 'Integral CF',
			fontWeight: '500',
			fontSize: '14px',
			color: Colors['120E0D'],
			textTransform: 'uppercase',
		},

		'& .MuiInput-input::placeholder': {
			opacity: 1,
			fontFamily: 'Integral CF',
			fontWeight: '500',
			fontSize: '14px',
			color: Colors['120E0D'],
			textTransform: 'uppercase',
		},
	},
	inputStyles: {
		maxHeight: '2rem',
		padding: '0.5rem',
	} as CSSProperties,
});
